/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_How_Show_TitleInputs */

const en_landing_how_show_title = /** @type {(inputs: Landing_How_Show_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show up`)
};

const pl_landing_how_show_title = /** @type {(inputs: Landing_How_Show_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przyjdź`)
};

/**
* | output |
* | --- |
* | "Show up" |
*
* @param {Landing_How_Show_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const landing_how_show_title = /** @type {((inputs?: Landing_How_Show_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_How_Show_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_landing_how_show_title(inputs)
	return en_landing_how_show_title(inputs)
});